export default function CategoryItemDirective() {
  return {
    template: require('./category-item.html'),
    scope: {
      categoryId: '=',
      item: '=',
      agendaIsActive: '=',
      canEdit: '=',
      canDelete: '=',
      canChangeStatus: '='
    },
    controller: 'CategoryItemController',
    controllerAs: 'categoryItemVM',
    bindToController: true,
    replace: true
  };
}
